import { Translations } from '../types/i18n';

export const en: Translations = {
  nav: {
    home: 'Home',
    metrics: 'Metrics',
    about: 'About',
    projects: 'Projects',
    experience: 'Experience & Leadership',
    skills: 'Skills',
    education: 'Education & Certifications',
    contact: 'Contact',
    portfolio: 'Jesús Gil'
  },
  hero: {
    greeting: 'Hi, I am',
    viewProjects: 'Explore Projects',
    downloadCV: 'View / Download CV',
    contactMe: 'Get in Touch',
    statusAvailable: 'Available On-site/Hybrid in Caracas or 100% Remote',
    verifiedStats: 'Verified Engineering Metrics'
  },
  sections: {
    metricsTitle: 'Impact Metrics',
    metricsSubtitle: 'Real-time performance, algorithmic activity, and verified contributions',
    aboutTitle: 'About Me',
    aboutSubtitle: 'Engineering from first principles, high-performance systems, and clean architecture',
    projectsTitle: 'Featured Projects',
    projectsSubtitle: 'Production systems, algorithmic engines, dApps, and AI agents',
    experienceTitle: 'Experience, Leadership & Achievements',
    experienceSubtitle: 'Tech community leadership, ICPC algorithmic contests, and hackathon victories',
    skillsTitle: 'Tech Stack & Competencies',
    skillsSubtitle: 'Layered mastery: from computer hardware and low-level systems to distributed backend and AI',
    educationTitle: 'Higher Education & Scholarships',
    educationSubtitle: 'Rigorous computer science curriculum and engineering excellence scholarships',
    certificationsTitle: 'Professional Certifications & Languages',
    languagesTitle: 'Languages',
    contactTitle: 'Contact & Networks',
    contactSubtitle: "Let's connect for engineering roles, challenging projects, or hackathons"
  },
  projectsFilter: {
    all: 'All',
    aiAgents: 'AI & Agents',
    backendFullstack: 'Backend & Full-Stack',
    web3: 'Web3',
    systemsAlgorithms: 'Systems & Algorithms',
    cybersecurity: 'Cybersecurity'
  },
  badges: {
    hackathonWinner: '1st Place Hackathon',
    topLatam: 'Top 27 LATAM',
    privateRepo: 'Private Code / Hackathon',
    verifiedCredential: 'Verified Credential'
  },
  buttons: {
    viewLiveDemo: 'Live Demo',
    viewRepository: 'Repository',
    verifyCredential: 'Verify on Credly',
    sendMessage: 'Send Message',
    downloadCV: 'Download CV (Drive)',
    sourceMetric: 'Verify Source'
  },
  contact: {
    getInTouch: "Let's Start a Conversation",
    getInTouchDescription: 'Available for Software Engineer roles (Backend, Full-Stack, Systems, AI) or high-impact projects.',
    contactInfo: 'Contact Information',
    socialProfiles: 'Verified Channels & Profiles',
    location: 'Caracas, Venezuela',
    availability: 'On-site / Hybrid in Caracas or Global Remote',
    form: {
      name: 'Your Name',
      email: 'Email Address',
      subject: 'Subject / Purpose',
      message: 'Message',
      namePlaceholder: 'Full name or company',
      emailPlaceholder: 'email@example.com',
      subjectPlaceholder: 'Job opportunity, project, or collaboration...',
      messagePlaceholder: 'Tell me about the project, role, or idea...',
      sendButton: 'Send Message',
      sendingButton: 'Sending...',
      successMessage: 'Message sent successfully! I will get back to you shortly.',
      privacyText: 'Your information is only used to respond to your inquiry.'
    }
  },
  footer: {
    role: 'Software Engineer | Backend & Full-Stack | Low-Level Systems, Applied AI & Web3',
    builtWith: 'Built with React, TypeScript, and Tailwind CSS. Hosted on GitHub Pages.',
    allRightsReserved: 'All rights reserved.',
    backToTop: 'Back to top'
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    close: 'Close',
    search: 'Search...',
    all: 'All',
    stars: 'stars on GitHub'
  }
};